import(/* webpackMode: "eager" */ "/home/kehutanan-web/kehutanan-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/kehutanan-web/kehutanan-web/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/kehutanan-web/kehutanan-web/src/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/home/kehutanan-web/kehutanan-web/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Figtree\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"style\":[\"normal\",\"italic\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/footer.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GaListener"] */ "/home/kehutanan-web/kehutanan-web/src/components/ga-listener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/navbar.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/progress-bar.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/survey-button.comp.tsx");
